import { euro } from "./preisAnalyse.js";

/**
 * Fragen zur Vergleichsseite. Sie beantworten, was die Liste selbst nicht
 * zeigen kann: wie die Werte zustande kommen und was sie bedeuten.
 */
export function vergleichFaq(analyse, merkmale) {
  if (!analyse) return [];

  const digital = analyse.nachDruck.find((g) => g.label.includes("digital"));
  const flatrate = analyse.nachDruck.find((g) => g.label.includes("Flatrate"));

  return [
    {
      question: "Sind die Preise im Vergleich Endpreise?",
      answer: `Die angezeigten Preise sind Grundpreis plus gewähltes Paket. Bei Versandboxen ist die Lieferung enthalten. Bei Anbietern vor Ort kommt je nach Entfernung eine Anfahrtspauschale dazu — sie wird berechnet, sobald du deine Postleitzahl eingibst.`,
    },
    {
      question: "Wie kommt die Bewertung von Bild und Licht zustande?",
      answer: `Nach einer festen Tabelle: Eine Spiegelreflex- oder Systemkamera bekommt dieselbe Note, egal von welchem Anbieter sie stammt — ${merkmale.spiegelreflex} der ${merkmale.anzahlBoxen} Fotoboxen haben eine. Beim Licht zählt, ob geblitzt wird (${merkmale.studioblitz} von ${merkmale.anzahlBoxen}). Wir testen die Boxen nicht selbst.`,
    },
    {
      question: "Was kostet die günstigste Fotobox im Vergleich?",
      answer: `Das günstigste Paket liegt bei ${euro(analyse.gesamt.min)} €${digital ? " und ist ein rein digitales Angebot ohne Drucker" : ""}. Über alle ${analyse.anzahlPakete} Pakete liegt die Hälfte unter ${euro(analyse.gesamt.median)} €.`,
    },
    {
      question: "Wonach sollte ich zuerst filtern?",
      answer:
        "Nach der Gästezahl. Sie entscheidet, ob der Drucker reicht — der häufigste Grund für Ärger am Eventabend. Danach der Lieferweg: Versandboxen sind günstiger, Anbieter vor Ort nehmen den Aufbau ab.",
    },
    {
      question: "Lohnt sich eine Druck-Flatrate?",
      answer: flatrate
        ? `Ab etwa 80 Gästen ja, und immer dann, wenn ihr ein Gästebuch führt — dann druckt die Box jedes Motiv zweimal. Flatrate-Pakete liegen im Median bei ${euro(flatrate.median)} €.`
        : "Ab etwa 80 Gästen ja, und immer dann, wenn ihr ein Gästebuch führt — dann druckt die Box jedes Motiv zweimal.",
    },
    {
      question: "Kann ich direkt über den Vergleich buchen?",
      answer:
        "Bei einem Teil der Anbieter ja — dort führt der Knopf zu einer Angebotsseite mit Anfrage und Bezahlung. Bei den übrigen leiten wir zum Anbieter weiter, der die Buchung selbst abwickelt.",
    },
  ];
}
